import { message } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../../../../constants/service/common/utilConstants';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import { csInquiryActions } from '../../../../../store/modules/cs/inquiry';
import {
  CS_INQUIRY_LIST_FILTER_OPTION_MODEL,
  CS_INQUIRY_LIST_SORT_OPTION_MODEL,
} from '../../../../../store/modules/cs/inquiry/models';
import CsInquiryList from '../CsInquiryList';

const CsInquiryListWrap = () => {
  const { email } = useSelector((state) => state.app.adminInfo);
  const csInquiryList = useSelector((state) => state.csInquiry.csInquiryList);
  const dispatch = useDispatch();

  const getList = (data) => {
    const { filterOption, sortOption, pagination } = csInquiryList;
    dispatch(
      csInquiryActions.getCsInquiryList({
        filterOption,
        sortOption,
        pagination,
        ...data,
      }),
    );
  };

  /**
   * 엑셀 다운로드
   */
  const getExcelDownload = () => {
    if (!csInquiryList || !csInquiryList.list.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    dispatch(
      csInquiryActions.getInquiryExcelDownload({
        email,
        filterOption: csInquiryList.filterOption,
        sortOption: csInquiryList.sortOption,
      }),
    );
  };

  useEffect(() => {
    getList({
      filterOption: CS_INQUIRY_LIST_FILTER_OPTION_MODEL,
      sortOption: CS_INQUIRY_LIST_SORT_OPTION_MODEL,
      pagination: LIST_PAGINATION_MODEL,
    });
  }, []);

  return (
    <div className="cs-inquiry-list-wrap">
      {/* 1:1 문의 리스트 */}
      <CsInquiryList csInquiryList={csInquiryList} getList={getList} getExcelDownload={getExcelDownload} />
    </div>
  );
};

export default CsInquiryListWrap;
